import OrderCargoOrderHistoryRequest from "../../../../api/raily/order/cargo-order/history/order-cargo-order-history.request";
import OrderCargoOrderHistoryParams from "./order-cargo-order-history-params";

const create = (
  loadParams: OrderCargoOrderHistoryParams,
): OrderCargoOrderHistoryRequest => {
  return {
    orderUuid: loadParams.orderUuid,
  };
};

const orderCargoOrderHistoryParamsFactory = {
  create,
};

export default orderCargoOrderHistoryParamsFactory;
